//---------
// is UUID
//---------
export default function isUuid(value) {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
  if (typeof value !== 'string') return false
  return uuidRegex.test(value)
}
